<template>
  <div class="wrapper">
    <v-head></v-head>
    <v-sidebar></v-sidebar>
    
    <div class="content-box" :class="{'content-collapse':collapse}">
      <div
        class="content fff"
        v-loading.fullscreen.lock="$store.state.loading"
        element-loading-text="loading"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <transition name="move" mode="out-in">
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive" class="page"></router-view>
          </keep-alive>
        </transition>
        <transition name="move" mode="out-in">
          <router-view class="page" v-if="!$route.meta.keepAlive"></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import vHead from "./common/Header.vue";
import vSidebar from "./common/Sidebar.vue";
export default {
  
  data() {
    return {
      collapse: false,
      isRouterAlive: true,
      
    };
  },
  components: {
    vHead,
    vSidebar
  },
  created () {
    console.log(this.$route)
  }
};
</script>
<style lang="less" scoped>
.content-box {
  padding-left: 161px;
}
</style>